import LocalizedStrings from 'react-localization';

import fallbackLocalizationCodes from '../../consts/localization/fallbackLocalizationCodes';
import defaultLocalizationDictionariesService from './defaultLocalizationDictionaries/defaultLocalizationDictionariesService';

class LocalizationManager {
    constructor() {
        if (LocalizationManager.instance) {
            return LocalizationManager.instance;
        }
        LocalizationManager.instance = this;

        this.fallbackMarketCode = fallbackLocalizationCodes.marketCode;
        this.fallbackLanguageCode = fallbackLocalizationCodes.languageCode;
        this.fallbackDictionary = defaultLocalizationDictionariesService.getDefaultDictionaryFromCode(
            this.fallbackLanguageCode
        );
        this.fallbackLocalizationName = `${this.fallbackMarketCode}_${this.fallbackLanguageCode}`;
        this.localization = null;
        this.configure();
    }

    getInstance() {
        if (!LocalizationManager.instance) {
            LocalizationManager.instance = new LocalizationManager();
        }
        return LocalizationManager.instance;
    }

    async configure() {
        const fallbackLocalizationName = `${this.fallbackMarketCode}_${this.fallbackLanguageCode}`;
        const dictionaries = {
            [fallbackLocalizationName]: this.fallbackDictionary,
        };
        const options = {logsEnabled: false};

        this.localization = new LocalizedStrings(dictionaries, options);
    }

    getLocalization() {
        return this.localization;
    }
}

export default LocalizationManager;
